import rateLimit from './rateLimit';

export { default as rateLimit } from './rateLimit';

export default {
  rateLimit,
};
